import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { APIError } from '@/types/APIError';
import Axios from 'axios';
import { ErrorHandler } from '@/utils/ErrorHandler';
import Vue from 'vue';
//import store from '@/store';
import router from '@/router';

declare module 'axios' {
  interface AxiosResponse<T = any> extends Promise<T> {}
}

let pendingRequests : Array<AxiosRequestConfig> = new Array<AxiosRequestConfig>();

export abstract class HttpClient {
  protected readonly instance: AxiosInstance;

  public constructor(baseURL: string) {
    this.instance = axios.create({
      baseURL,
    });
    this._initializeRequestInterceptor();
    this._initializeResponseInterceptor();
  }

  /* private _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(
            this._handleRequest,
            //this._handleError
    );
  }; */

  private _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(async config => {
        //attach the current project id to every outgoin request
        /* const projectId = router.currentRoute.params.projectId;
        if(projectId != '' && projectId != undefined) {
            config.headers['X-ProjectId'] = projectId;
        } */
        const token = localStorage.getItem('token');
        if(token != '' && token != undefined) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        //TO BE TESTED remove content-type
        
        //check token expiration
        const timeMargin = 10000; //10 seconds margin for Production
        //const timeMargin = 280000; //280 seconds margin for quicker testing
        /* let expires_at = Date.now();
        const stored_expires_at = localStorage.getItem('expires_at'); //anything from the localStorage is a string
        if(stored_expires_at) {
            expires_at = Number(stored_expires_at).valueOf();
        } */
        const expires_at : number = Number(localStorage.getItem('expires_at')!.valueOf()); //anything from the localStorage is a string
        const now = Date.now();
        //console.log("Is token expired?", now + timeMargin, expires_at, now + timeMargin >= expires_at, expires_at - (now + timeMargin) )
        //console.log("Is token expired?", now + timeMargin >= expires_at, expires_at - (now + timeMargin), config.url )
        //if the token is supposedly expired
        if(now + timeMargin >= expires_at) {
            const already_refreshing = localStorage.getItem('refresh_attempt');
            
            //if there is no refresh_attempt item in the localStorage already
            //or if that refresh_attempt was created 10 seconds ago or more (ie. previous refresh got interrupted and need to be performed again)
            if(!already_refreshing || parseInt(already_refreshing) + 10000 <= now) {
                localStorage.setItem('refresh_attempt', Date.now().toString());
                config = await this.tokenRefresh(config)
                //.then(updated_config => new Promise(resolve=> setTimeout(() => resolve(updated_config), 100)));
                .then(updated_config => {
                    localStorage.removeItem('refresh_attempt');
                    return updated_config;
                })
                .catch( (error : AxiosError) => {
                    //console.log("Received rejection from tokenRefresh", error);
                    localStorage.removeItem('refresh_attempt');
                    return Promise.reject(error)
                })
                .finally(() => {
                    localStorage.removeItem('refresh_attempt');
                });
                return config;
            }
            // else the token is expired and someone else (ie. another HTTPClient instance) is refreshing the token
            // this instance should then add their request to the queue and finish here.
            // the instance that is refreshing should pick it up right after the token has been refreshed.
            // **** SOLVE / IMPROVE HERE !!!! *****
            else {
                const idx = pendingRequests.indexOf(pendingRequests.filter(request => request.url == config.url)[0]);
                if(idx == -1) {
                    //console.log("Adding request to queue", config.url, pendingRequests.length);
                    pendingRequests.push(config);
                }
                //console.log("Pending requests", pendingRequests);
                //Try again with the updated config containing pending request(s)
                //return Promise.resolve(config);
                const customResponse : AxiosResponse = {
                    data: {},
                    status: 202,
                    statusText: "Request queued",
                    headers: {},
                    config,
                    request: {},
                } as AxiosResponse
                const customError =   {
                    config: config,
                    response: customResponse,
                    isAxiosError: true
                } as AxiosError;
                return Promise.reject(customError);
            }
        }
        else {
            return config;
        }
    });
  };

  private _handleRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    //attach the current project id to every outgoin request
    const projectId = router.currentRoute.params.projectId;
    if(projectId != '' && projectId != undefined) {
        config.headers['X-ProjectId'] = projectId;
    }
    const token = localStorage.getItem('token');
    if(token != '' && token != undefined) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    //check token expiration
    const timeMargin = 10000; //10 seconds margin
    //timeMargin = 280000; //280 seconds margin for quicker testing
    const expires_at : number = Number(localStorage.getItem('expires_at')!.valueOf()); //anything from the localStorage is a string
    const now = Date.now();
    //console.log("Is token expired?", now + timeMargin, expires_at, now + timeMargin >= expires_at, expires_at - (now + timeMargin) )
    //if the token is supposedly expired
    if(now + timeMargin >= expires_at) {
        const already_refreshing = localStorage.getItem('refresh_attempt');

        if(!already_refreshing) {
            this.tokenRefresh(config)
            .then(updated_config => {
                config = updated_config;
            });
            return config;
        }
        else {
            return config;
        }
    }
    else {
        return config;
    }
  };

  private _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      this._handleResponse,
      this._handleError,
    );
  };

  private _handleResponse = (response : AxiosResponse) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    //console.log("HttpClient Response Interceptor", response);
    return response;
  };

  private async tokenRefresh(config : AxiosRequestConfig) {
    //console.log("About to refresh token", config);
    const refresh_endpoint = process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_AUTH_SUFFIX + 'refresh';
    const refresh_token = this.getLocalRefreshToken();
    //const refreshTimeMargin = 1750000; //for testing purposes, should be 10000 (10 seconds in Production)
    const refreshTimeMargin = 10000; //for Production
    const refresh_token_expires_at = Number(localStorage.getItem('refresh_expires_at')!.valueOf());
    const now = Date.now();
    console.log("Is refresh token expired?", now + refreshTimeMargin, refresh_token_expires_at, now + refreshTimeMargin >= refresh_token_expires_at, refresh_token_expires_at - (now + refreshTimeMargin) )
    //if the refresh token is supposedly expired, this will be true
    const refresh_token_expired = now + refreshTimeMargin >= refresh_token_expires_at;

    //if(!refresh_token_expired && refresh_token != null) {
    if(!refresh_token_expired) {
        //localStorage.setItem('refresh_attempt', Date.now().toString());
        //we don't use the actual current instance to avoid infinite loop with the request interceptor getting fired all the time.
        //console.log("Now about to refresh token - refresh token is not expired", refresh_token);
        const response = await Axios.post(refresh_endpoint, {
            refresh_token: refresh_token,
        })
        .then(response => {
            //console.log("Token refreshed", response);
            //now that the token is refreshed, let's check if there is any pending requests that is waiting to be processed
            if(pendingRequests.length > 0) {
                pendingRequests.forEach((request : AxiosRequestConfig) => {
                    console.log("Resubmitting request", request.url, request.headers['Authorization']);
                    //we replay each request which will replace the expired token with the new token
                    this.instance(request);
                });
                pendingRequests = new Array<AxiosRequestConfig>();
            }
            return response;
        })
        .catch(error => {
            const err : APIError = error as APIError;
            //console.log("Error when refreshing token - probably that the refresh token is expired", err)
            if(err.internal_code == 'TRUSTID_TOKEN_ERROR') {
                //Refresh token is probably expired too, we should completely logout the user 
                //and redirect them to the login page
                //console.log("Token Error");
                this.forceLogout();
                return Promise.reject(error);
            }
            else {
                return Promise.reject(error);
            }
        })
    
        //console.log("Transmitted refresh_token from localStorage: ", response.data.message);
        localStorage.setItem('token', response.data.token.access_token);
        localStorage.setItem('id_token', response.data.token.id_token);
        if(response.data.token.refresh_token != null) {
            localStorage.setItem('refresh_token', response.data.token.refresh_token);
        }
        localStorage.setItem('user', JSON.stringify(response.data.usr));

        const token_expiration = Date.now() + (response.data.token.expires_in.valueOf() * 1000);
        localStorage.setItem('expires_at', token_expiration.toString());

        const refresh_expiration = Date.now() + (response.data.token.refresh_expires_in.valueOf() * 1000);
        localStorage.setItem('refresh_expires_at', refresh_expiration.toString());

        //localStorage.removeItem('refresh_attempt');

        //inject the newly refreshed token in the current Request config
        config.headers['Authorization'] = `Bearer ${response.data.token.access_token}`;
        
        //return the corrected config
        return config;
    }
    else {
        console.log("Refresh token is expired - force logout");
        this.forceLogout();
        return Promise.reject();
    }
  }

  private getLocalRefreshToken() {
    const refreshToken = localStorage.getItem("refresh_token");
    return refreshToken; 
  }

  protected _handleError = (error: any) => {
        //console.log("GOT AN ERROR", error.response.status, error.response.data.internal_code)
        //console.log("GOT AN ERROR", error, typeof error)
        if(error.response.status == 202) {
            //console.log("HTTP error handler", error.response.status, error.response.statusText, pendingRequests);
            return Promise.reject(error.response.data);
        }
        else if(error.response.status === 503) {
            router.push({
                name: 'maintenance'
            })
        }
        //scenario for when the API replies with a not found message
        else if(error.response.status === 404) {
            router.push({
                name: 'not-found'
            });
            Vue.$toast.error(error.response.data.message);
        }
        else if((error.response.status === 401 || error.response.status === 400) &&
        (
            error.response.data.internal_code == 'AUTH' 
            || error.response.data.internal_code == 'AUTH_NO_TOK' 
            || error.response.data.internal_code == 'AUTH_EXP_TOK' 
            || error.response.data.internal_code == 'AUTH_BE_TOK' 
            || error.response.data.internal_code == 'AUTH_INV_TOK'
            || error.response.data.internal_code == 'TRUSTID_TOKEN_ERROR'
            || error.response.data.internal_code == 'TRUSTID_INV_AZP'
        )) {
            //return the rejected promise
            //return Promise.reject(error.response.data);
            const refreshAttempted = localStorage.getItem('refresh_attempt');
            const refreshToken = localStorage.getItem('refresh_token');
            const originalConfig = error.config;
            //console.log("Issue with token expired", originalConfig);
            const expiredAt = localStorage.getItem('refresh_expires_at');
            if(!refreshAttempted && refreshToken != null) {
            //if(originalConfig._retry != true && refreshToken != null) {
                originalConfig._retry = true;
                localStorage.setItem('refresh_attempt', Date.now().toString());
                //console.log("Now trying to refresh it", refreshAttempted, originalConfig._retry);

                const refresh_endpoint = process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_AUTH_SUFFIX + 'refresh';
                //console.log("About to refresh the token", refreshToken);
                this.instance.post(refresh_endpoint, {
                    refresh_token: refreshToken,
                })
                .then(response => {
                    //console.log("Transmitted TrustID code from LocalStorage", response.data);
                    localStorage.setItem('token', response.data.token.access_token);
                    if(response.data.token.refresh_token != null) {
                        localStorage.setItem('refresh_token', response.data.token.refresh_token);
                    }
                    //console.log("user received after refresh", response.data.usr, Axios.request(originalConfig))
                    localStorage.setItem('user', JSON.stringify(response.data.usr));
                    const expiration = Date.now() + (response.data.token.expires_in.valueOf() * 1000)
                    localStorage.setItem('expires_at', expiration.toString());
                    localStorage.removeItem('refresh_attempt');
                    //inject the newly refreshed token
                    originalConfig.headers['Authorization'] = `Bearer ${response.data.token.access_token}`;
                    //return Promise.resolve(true);
                    //retries the original request with updated auth token
                    return Axios.request(originalConfig);
                })
                .catch(error => {
                    const err : APIError = error as APIError;
                    if(err.internal_code == 'TRUSTID_TOKEN_ERROR' || error.response.data.internal_code == 'TRUSTID_INV_AZP') {
                        //Refresh token is probably expired too, we should completely logout the user 
                        //and redirect them to the login page
                        //console.log("Token Error");
                        this.forceLogout();
                    }
                });
            }
            else if(refreshToken == null) {
                this.forceLogout();
            }
            else if(expiredAt && refreshAttempted && refreshAttempted > expiredAt + 60000) {
                this.forceLogout();
            }
            else {
                //refresh is being attempted by another instance of HTTPClient
                //I should wait and retry later
                //this.forceLogout();
                //console.log("Refresh in progress, will resubmit request later");
            }
        }
        //scenario for when the API replies with a not authorized message for a WRITE request (ie. different from GET)
        else if(error.response.status === 401 && 
            error.response.config.method != 'get' &&
            (error.response.data.internal_code == 'AUTH_PRO'
            || error.response.data.internal_code == 'TRUSTID_INV_AZP')
        ) {
            Vue.$toast.error(error.response.data.message);
        }
        //scenario for when the API replies with a not authorized message for a READ request (ie. GET requests)
        else if(error.response.status === 401 && 
            error.response.config.method == 'get' &&
            (error.response.data.internal_code == 'AUTH_PRO'
            || error.response.data.internal_code == 'TRUSTID_INV_AZP')
        ) {
            router.push({
                name: 'not-authorized'
            });
        }
        //scenario for when the API replies with a message related to TRUSTID issues for e-mail address not confirmed yet
        else if(error.response.status === 401 && 
            error.response.data.internal_code == 'TRUSTID_EMAIL_NOT_VERIFIED'
        ) {
            Vue.$toast.error("Login fehlgeschlagen - Ihre E-Mail-Adresse wurde nicht überprüft. Bitte wenden Sie sich an den CRB-Support");
        }
        //scenario for when the API replies with a message related to TRUSTID issues for lack of client role
        else if(error.response.status === 401 && 
            error.response.data.internal_code == 'TRUSTID_NO_CRB_KUNDE_ROLE'
        ) {
            Vue.$toast.error("Es ist leider ein Fehler aufgetreten. Bitte melden Sie sich ab und wieder an. Falls dies nicht zielführend ist, kontaktieren Sie bitte CRB unter support@crb.ch.");
        }
        else {
            const errorHandler : ErrorHandler= new ErrorHandler();
            error.response.data.message = errorHandler.process(error.response.data);
            Vue.$toast.error(error.response.data.message);
            return Promise.reject(error.response.data);
        }
    };
    
    private forceLogout() {
        const auth_endpoint = localStorage.getItem('authorization_endpoint');

        if(auth_endpoint != null) {

            // we override auth_endpoint to reflect the current location for the redirect_uri parameter
            //const actual_location = window.location.origin + window.location.pathname;
            //const corrected_redirect_uri = auth_endpoint.replace(/redirect_uri.*/, "redirect_uri="+actual_location);
            //console.log("Forcing clean logout and redirecting to ", corrected_redirect_uri);

            localStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.removeItem('id_token');
            //localStorage.removeItem('refresh_token');
            localStorage.removeItem('code');
            localStorage.removeItem('session_state');
            localStorage.removeItem('refresh_attempt');
            //localStorage.removeItem('password_reset_location');
            //localStorage.removeItem('account_edit_location');

            //window.location.href = corrected_redirect_uri;
            router.push({
                name: 'login',
                params: { message: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.' }
            })
        }
    }
}